export default {
    companySetting: 'Company Setting',
    profile: 'Profile',
    userManagement: 'User Management',
    position: 'Position Lists',
    bureau: 'Bureau lists',
    nbtc: 'NBTC',
    headQuarter: 'Head Quarter'
}
